import { useCallback, useEffect, useState } from 'react';
import api from './api';

export const notifyDataChanged = () => window.dispatchEvent(new Event('homeSmartDataChanged'));

export const cancellationApi = {
  list: () => api.get('/home-smart/cancelled'),
  cancel: (kind, id) => api.post(`/home-smart/${kind}/${id}/cancel`, {}, { skipRetry: true }).then((r) => { notifyDataChanged(); return r; }),
  restore: (kind, id) => api.post(`/home-smart/${kind}/${id}/restore`, {}, { skipRetry: true }).then((r) => { notifyDataChanged(); return r; }),
};

// Only the account owner gets data back; anyone else sees no cancel/restore controls.
export const useCancelled = (enabled) => {
  const [data, setData] = useState(null);
  const reload = useCallback(async () => {
    if (!enabled) return;
    try { setData((await cancellationApi.list()).data); } catch { setData(null); }
  }, [enabled]);
  useEffect(() => { reload(); }, [reload]);
  return { available: !!data, bookings: data?.bookings || [], closures: data?.closures || [], reload };
};
